import { IWidgetOptionItem } from '@livelike/javascript';
import { widgetStore } from '../store';
import { useSelectedFieldStore } from './useSelectedFieldStore';

export type UseWidgetOptionsArg = {
  widgetId: string;
};

export function useWidgetOptions({
  widgetId,
}: UseWidgetOptionsArg): IWidgetOptionItem[] {
  const widgetOptions = useSelectedFieldStore(widgetStore, () => {
    const widgetPayload = widgetStore.get()[widgetId]?.widgetPayload;
    if (widgetPayload) {
      return widgetPayload.options;
    }
    return undefined;
  });
  return widgetOptions;
}
